import React from 'react';
import {
  FDContentContainer, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useFormActions } from 'Views/Page/Content/RightSidebar/Content/Templates/DefaultTemplate/Layout/useFormActions';
import WizardStepDeleteButton
  from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content/WizardStepDeleteButton';
import ActionsRow from 'Components/ComponentLibrary/Atoms/Layout/ActionsRow';
import MetaLayoutFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutFields';
import RelationshipLinks from './RelationshipLinks';

const Layout = () => {
  const { resource } = useMetaLayoutContext();

  const {
    showActions,
    showSubmitButton,
    showDeleteButton,
    handleSubmit,
    handleDelete,
    onDeleteSuccess,
    submitting,
  } = useFormActions(resource);

  return (
    <FDContentContainer maxWidth={'sm'}>
      <FDStack spacing={2} direction="column" alignItems="center">
        <MetaField attr="title" />
        <MetaLayoutFields
          resource={resource}
        />
        <RelationshipLinks resource={resource} />
        {showDeleteButton ? (
          <WizardStepDeleteButton
            onDelete={handleDelete}
            onDeleteSuccess={onDeleteSuccess}
            dialogProps={{
              title: 'Are you sure?',
              message: 'Removing this item will delete all of its information. This cannot be undone.',
              cancelLabel: 'Nevermind',
              confirmLabel: 'Remove',
            }}
          />
        ) : null}
        {showActions ? (
          <ActionsRow>
            {showSubmitButton ? (
              <FDPrimaryActionButton
                label="Submit"
                onClick={handleSubmit}
                isFullWidth
                size="lg"
                loading={submitting}
                disabled={submitting}
              />
            ) : null}
          </ActionsRow>
        ) : null}
      </FDStack>
    </FDContentContainer>
  );
};

export default Layout;
